import { Component } from '@angular/core';

@Component({
  selector: 'xp-patient',
  templateUrl: './patient.component.html',
  styleUrl: './patient.component.scss'
})
export class PatientComponent {

}
